/* eslint-disable camelcase */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiClient from 'src/api/api-client';
import { getNewURI, updateNewStatusURI, uploadFileURI } from '../api';
import { setValue } from './MessageSlice';

// First, create the thunk

export const uploadImageNews = async image => {
  const payload = new FormData();
  if (image) {
    payload.append('file', image);
    const res = await apiClient.handleRequest({
      method: 'post',
      url: `${uploadFileURI}`,
      data: payload,
    });
    return res.data;
  }
  return false;
};

export const fetchNews = createAsyncThunk(
  'news/fetchNews',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'get',
          url: `${getNewURI}`,
          params: { ...params, get_all: true },
        })
        .then(res => res.data);
      return response.data;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const searchNews = createAsyncThunk(
  'news/searchNews',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'get',
          url: `${getNewURI}`,
          params: { ...params, get_all: true },
        })
        .then(res => res.data);
      return response.data;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const upsertNew = createAsyncThunk(
  'news/upsertNew',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      await apiClient
        .handleRequest({
          method: 'post',
          url: `${updateNewStatusURI(data.id)}`,
          data: data.data,
        })
        .then(res => res.data);
      let currentPage = 1;
      if (data.id) {
        const state = getState();
        currentPage = state.new.currentPage;
      }
      dispatch(fetchNews({ page: currentPage }));
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);
export const updateNewStatus = createAsyncThunk(
  'news/updateNewStatus',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      await apiClient
        .handleRequest({
          method: 'post',
          url: `${updateNewStatusURI(data.id)}`,
          data: { ...data, status: data.status === 'inactive' ? 'active' : 'inactive' },
        })
        .then(res => res.data);
      let currentPage = 1;
      if (data.id) {
        const state = getState();
        currentPage = state.new.currentPage;
      }
      dispatch(fetchNews({ page: currentPage }));
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

export const deleteNews = createAsyncThunk(
  'news/updateNewStatus',
  async (data, { rejectWithValue, dispatch, getState }) => {
    try {
      await apiClient
        .handleRequest({
          method: 'delete',
          url: `${updateNewStatusURI(data.id)}`,
        })
        .then(res => res.data);
      let currentPage = 1;
      if (data.id) {
        const state = getState();
        currentPage = state.new.currentPage;
      }
      dispatch(fetchNews({ page: currentPage }));
      return true;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);
// Then, handle actions in your reducers:
const newSlice = createSlice({
  name: 'new',
  initialState: {
    entities: [],
    loading: 'idle',
    saving: 'idle',
    currentRequestId: undefined,
    error: null,
    currentPage: 1,
    totalPage: 1,
    total: 0,
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    [fetchNews.pending]: (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchNews.fulfilled]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        const { data, last_page, current_page, total } = action.payload;
        state.loading = 'idle';
        state.entities = data;
        state.currentPage = current_page;
        state.totalPage = last_page;
        state.currentRequestId = undefined;
        state.total = total;
      }
    },
    [fetchNews.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },

    [upsertNew.pending]: (state, action) => {
      if (state.saving === 'idle') {
        state.saving = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    [upsertNew.fulfilled]: (state, action) => {
      state.saving = 'idle';
    },
    [upsertNew.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.saving === 'pending' && state.currentRequestId === requestId) {
        state.saving = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
    [searchNews.fulfilled]: (state, action) => {
      const { data, last_page, current_page, total } = action.payload;
      state.loading = 'idle';
      state.entities = data;
      state.currentPage = current_page;
      state.totalPage = last_page;
      state.currentRequestId = undefined;
      state.total = total;
    },
  },
});

export default newSlice.reducer;
